export default __webpack_public_path__ + "assets/9a9d55fd81e4fd941cdda13d49a4d5eb.svg";